import { InjectionToken } from '@angular/core';

export const PCP_API_URL = new InjectionToken<string>('PCP_API_URL');
